export { default } from './JoinAccount.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccount/index.js